export function normalizeActiveStorageUrl(url?: string, fallback = "") {
  if (!url) return fallback;

  try {
    const baseUrl = typeof window !== "undefined" ? window.location.origin : "http://localhost";
    const parsedUrl = new URL(url, baseUrl);

    if (parsedUrl.pathname.startsWith("/rails/active_storage/")) {
      return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    }
  } catch (_error) {
    return url;
  }

  return url;
}
